import styled from 'styled-components';

import { white, gradient } from 'styles/colors';
import { backgroundImages } from 'polished';
import { fromLarge } from 'styleUtils/mediaQueries';
import { contentHeight } from './variables';

export const InfoWrapper = styled.div`
    position: relative;
    color: ${white};
    padding: 32px;

    p {
        color: ${white};
    }

    ${fromLarge`
        height: ${contentHeight};
    `};

    background-size: cover;
    ${backgroundImages(gradient, 'url("/images/office.jpg")')}
    .webp & {
        ${backgroundImages(gradient, 'url("/images/office.webp")')}
    }
`;
